import Vue from 'vue'
import Vuex from 'vuex'
import VuexI18n from 'vuex-i18n' // load vuex i18n module
import app from './modules/app'
import resumenVentas from './modules/reportes/resumenVentas'
import historico from './modules/productos/historico'
import consolidadoPeriodo from "./modules/finanzas/consolidadoPeriodo"
import sugeridoCompra from "./modules/compra/sugeridoCompra";
import voucher from "./modules/ventas/voucher";
import rendicion from "./modules/caja/rendicion";
import listadoProductos from "./modules/productos/listadoProductos";
import producto from "./modules/productos/producto";
import generarGuia from "./modules/bodega/generarGuia";
import movimiento from "./modules/movimiento/movimiento";
import mapeoBodega from "./modules/bodega/mapeoBodega";
import proveedores from "./modules/proveedores/proveedores"


import * as getters from './getters'

Vue.use(Vuex)

const store = new Vuex.Store({
  strict: true, // process.env.NODE_ENV !== 'production',
  getters,
  modules: {
    app,
    resumenVentas,
    historico,
    sugeridoCompra,
    consolidadoPeriodo,
    voucher,
    rendicion,
    listadoProductos,
    producto,
    generarGuia,
    movimiento,
    mapeoBodega,
    proveedores
  },
  state: {},
  mutations: {},
})

Vue.use(VuexI18n.plugin, store)

export default store
